import { useTranslations } from 'next-intl';
import styles from './LocationRow.module.css';
import { i18nMap, IconsPalette } from '../../constants';

const LocationCategory = ({ value }) => {
  const t = useTranslations();

  return <span className={styles.dropdown__status}>{t(i18nMap[value])}</span>;
};

export function LocationRow({ item, isActive, onSelect }) {
  return (
    <li
      className={`${styles.dropdown__row} ${
        isActive ? styles.dropdown__row_active : ''
      }`}
      onClick={onSelect}
    >
      <div className={styles.dropdown__icon}>
        {IconsPalette[item.data.type]}
      </div>
      <div className={styles.dropdown__content}>
        <LocationCategory value={item.data.type} />
        <p title={item.value}>{item.value}</p>
      </div>
    </li>
  );
}
